import { TourDefinition } from '@contexts/GuidedTourContext';

/**
 * Central registry of guided tours.
 *
 * Add a new entry here to make a tour available app-wide.
 * Use `tours.<name>.id` when calling `startTour()` so the ID is never a magic string.
 *
 * Every entry is automatically registered by GuidedTourProvider in App.tsx.
 */
export const tours = {
  createOrLogin: {
    id: 'select_action_create_or_log_into_account',
    steps: [
      {
        route: '/',
        element: '#welcome-options-buttons',
        popover: {
          title: 'Create or Log into Account',
          description: 'New here? Click to create your account and get connected.',
          side: 'bottom' as const,
          align: 'start' as const,
        },
      },
    ],
  },

  connectWifi: {
    id: 'select_action_connect_to_wifi_network',
    steps: [
      {
        route: '/',
        element: '#welcome-options-buttons',
        popover: {
          title: 'Connect to Wi-Fi',
          description: 'To connect, first log in or create an account.',
          side: 'bottom' as const,
          align: 'start' as const,
        },
      },
    ],
  },

  connectWired: {
    id: 'select_action_connect_to_wired_network',
    steps: [
      {
        route: '/',
        element: '#welcome-options-buttons',
        popover: {
          title: 'Connect to Wired Ethernet',
          description: 'To connect, first log in or create an account.',
          side: 'bottom' as const,
          align: 'start' as const,
        },
      },
    ],
  },
} satisfies Record<string, TourDefinition>;

/** Flat array passed to GuidedTourProvider for bulk registration */
export const tourList: TourDefinition[] = Object.values(tours);
